export default __webpack_public_path__ + "static/media/dec_con.1dd746e3.PNG";